import type { GroupMembershipRole as GroupMembershipRoleModel } from '@/adapters/catalogv1.g';

export function extractGroupMembershipRole(model: GroupMembershipRoleModel) {
  return {
    id: model._metadata?.distinct_id ?? '',
    groupRef: model.group_ref ?? '',
    principalRef: model.principal_ref ?? '',
    principalType: model.principal_type ?? '',
    role: model.role ?? '',
    nativeRole: model.native_role ?? '',
    tenantId: model._metadata?.tenant_id,
    connectorId: model._metadata?.segment_id,
  };
}

export type CatalogGroupMembershipRole = ReturnType<
  typeof extractGroupMembershipRole
>;
